<template >
    <div class="container-fluid" v-if="lesson">
      <div class="row">
        <div class="col col-md-8 col-sm-12">
            <div class="card shadow mb-4" v-if="topic && item">
              <div class="card-header py-3">
                <div class="row">

                    <div class="col">
                      <h4 class="m-0 font-weight-bold text-primary">{{topic.name}} / {{item.name}}</h4>
                      <p>Товч нэр: {{item.shortname}}</p>
                      <button @click="openSaveContentFileModal(topic, item)" class="btn btn-sm btn-mygray font-weight-bold mr-2">Файл оруулах</button>  
                                         <button @click="$router.push({ name: 'DetailQuestions', params: { lessonId: lesson.id, topicId: topic.id, detailId: item.id} })" class="btn btn-danger my-3 mr-2 btn-sm" v-if="item.type!=null && item.type!=undefined && item.type=='exam'">Шалгалтын асуулт бэлдэх</button>
                    
                      <button @click="$router.push({ name: 'DetailQuestions', params: { lessonId: lesson.id, topicId: topic.id, detailId: item.id} })" class="btn btn-danger my-3 mr-2 btn-sm" v-if="item.type!=null && item.type!=undefined && item.type=='test'">Тестын  асуулт бэлдэх</button>
                      <div v-if="item.graded && item.graded==true && item.totalScore">
                        <button class="btn btn-sm btn-primary mr-2" @click="$router.push({'name': 'ILessonContentScores', params: {lessonId: lessonId, topicId: topic.id, contentId: item.id} })">Дүн оруулах</button>
                      </div>
                      <button v-if="item.type!=null && item.type!=undefined && (item.type=='test' || item.type=='exam')" class="btn btn-sm btn-mygray font-weight-bold" @click="$router.push({ name: 'ExamResult', params: { lessonId: lessonId, topicId: topic.id, contentId: item.id} })">Дүн xараx</button>
                    </div>
                    
                    <div class="col-auto" v-if="item.type!=null && item.type!=undefined">
                        <span class="badge badge-warning">{{getType(item.type)}}</span>
                    </div>
                    <div class="col-auto">
                       <i class="fas fa-edit text" @click="_editContent(item,topic)" ></i>
                    </div>


                </div>
              </div>
              <div class="card-body" >
                  <div v-if="item">
                    <p class="mb-1">{{item.description}}</p>
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <p class="mb-1" v-if="item.duration"><span class="font-weight-bold">Үргэлжлэх хугацаа: </span>{{item.duration}} минут</p>
                        <p class="mb-1" v-if="item.time"><span class="font-weight-bold">Шалгалтын үргэлжлэх хугацаа: </span>{{item.time}} минут</p>
                        <p class="mb-1" v-if="item.startDay!=null"><span class="font-weight-bold">Эхлэх:</span> {{item.startDay | formatDate}}</p>
                        <p class="mb-1" v-if="item.endDay!=null"><span class="font-weight-bold">Дуусах:</span> {{item.endDay | formatDate}}</p>
                        <div v-if="item.type && item.type=='assignment'">
                          <p v-if="item.totalScore">
                            <span class="font-weight-bold">Дүгнэх дээд оноо: </span>{{item.totalScore}}
                          </p>
                          <span v-if="item.type && item.type=='assignment'">
                            <div v-if="item.showScore==true" style="cursor:pointer" @click="setPropContent(false,topic, item, 'showScore')"><span class="badge badge-success">Дүн харах боломжгүй болгох</span></div>
                            <div v-else @click="setPropContent(true,topic, item, 'showScore')" style="cursor:pointer"><span class="badge badge-danger">Дүн нээлттэй болгох</span></div>
                          </span>
                        </div>
                      </div>

                    </div>
                    
                    <hr/>

 

                    <div style="margin-bottom: 18px;"  v-if="item.videoUrl!=null">
                        <a v-bind:href="item.videoUrl" target="blank">  {{ item.videoUrl }} </a>
                        <br/>
                        <iframe width="100%" height="600" v-if="item.videoUrl!=null && item.videoUrl!='' && item.videoUrl.toLowerCase().indexOf('youtube') != -1" v-bind:src="getYoutubeIframe(item.videoUrl)"  frameborder="0" allowfullscreen></iframe>
                      
                    </div>


                    <div v-if="item.iframeurl && item.iframeurl!=''">
                      <div id="iframecontainer" v-html="item.iframeurl">
                      </div>
                    </div>

                    <div v-if="item.fileUrls!=null && item.fileUrls.length>0">
                      <hr/>
                      <h5 class="text-center">Файлууд</h5>
                      <table class="table table-bordered table-sm" >
                      
                        <tr v-for="(file, index) in item.fileUrls" >
                          <td>{{file.name}}</td>
                          <td>{{file.description}}</td>
                          <td>
                            
                            <button class="btn btn-outline-danger btn-sm mr-2"  @click="_deleteContentFile(topic, item, file, index)">устгах</button>
                            <a class="btn btn-outline-primary btn-sm mr-2" v-bind:href="file.link" target="_blank">
                              <i class="fas fa-download"></i> 
                              Татах
                            </a>
                          </td>
                        </tr>
                      </table>
                    </div>
                    
                    <section class="content-item" id="comments">
                      <div class="container">         
                        <div class="row">
                          <div class="col">   
                              <form>
                                <h3 class="pull-left">Сэтгэгдэл</h3>
                                
                                  <fieldset>
                                    <div class="row">
                                      
                                      <div class="form-group col-xs-12 col-sm-9 col-lg-10">
                                        <textarea v-model="commentText" rows="2" class="form-control" id="message" placeholder="Таны сэтгэгдэл" required=""></textarea>
                                      </div>
                                      <div class="col col-auto">
                                        <button @click="saveComment" type="button" class="btn btn-success pull-right">Илгээх</button>
                                      </div>
                                    </div>  	
                                  </fieldset>
                              </form>
                              
                              <h3 v-if="item.numberOfComments">{{item.numberOfComments}} сэтгэгдэл</h3>

                              <div class="media" v-for="comment in item.comments">
                                  <!-- <a class="pull-left" href="#"><img class="media-object" src="https://bootdey.com/img/Content/avatar/avatar1.png" alt=""></a> -->
                                  <div class="media-body">
                                      <h6 class="media-heading font-weight-bold" v-if="comment.customerData">{{comment.customerData.name}} / {{comment.customerData.code}}</h6>
                                      <p >{{comment.text}}</p>
                                      <ul v-if="comment.createdAt" class="list-unstyled list-inline media-detail pull-left">
                                          <li><i class="fa fa-calendar"></i>{{comment.createdAt | formatDate}}</li>
                                      </ul>
                                    
                                  </div>
                              </div>
                              
                          
                          </div>
                          </div>
                      </div>
                  </section>


                  </div>

              </div>
            </div>
            <hr class="mb-5"/>
        </div>
        <div class="col col-md-4 col-sm-12">

          <div>
            <div class="card pl-3">
              <h4 class="p-3 text-center">Xичээлүүд</h4>
              <div v-for="(topic,index) in topics" v-bind:key="topic.id" v-if="topics!=null && topics.length>0 && topic && topic.details && topic.details.length>0">
                  <h5 class="card-title text-primary mb-0 mt-2 font-weight-bold">Сэдэв {{index+1}}: {{topic.name}}</h5>
                  <hr class="mt-0"/>
                  <div class="row mb-2" v-for="(item, index) in topic.details" v-bind:key="item.id" @click="setCurrentVideo(topic, item)">
                      <div class="col-md-4">
                          <div v-if="item.videoUrl">
                              <a style="cursor:pointer">
                                  <img style="width: 100%;" :src="getYoutubeImg(item.videoUrl)" alt="">
                              </a>
                          </div>
                          <!-- <div v-else class="my-2">
                             <a style="cursor:pointer">
                                  <img style="width: 100%;" :src="'https://via.placeholder.com/300x200/09f/fff.png?text='+item.name" alt="">
                              </a>
                          </div> -->
                          <div v-else class="my-2">
                            <a style="cursor:pointer">
                                <!-- <img style="width: 100%;" :src="'https://via.placeholder.com/300x200/09f/fff.png?text='+item.name" alt="">  -->

                                <div v-if="item.type=='lecture'" style="text-align:center;color:white; height:100px!important;background-color:blue;line-height: 100px;" class="bg-primary">
                                  {{item.name}} 
                                </div> 
                                <div v-else-if="item.type=='test'" style="text-align:center;color:white; height:100px!important;background-color:blue;line-height: 100px;" class="bg-primary">
                                  {{item.name}} 
                                </div> 
                                <div v-else-if="item.type=='assignment'" style="text-align:center;color:white; height:100px!important;background-color:blue;line-height: 100px;" class="bg-danger">
                                  {{item.name}} 
                                </div> 
                                <div v-else style="text-align:center;color:white; height:100px!important;background-color:blue;line-height: 100px;" class="bg-info">
                                  {{item.name}} 
                                </div> 
                            </a>
                          </div>

                      </div>

                          

                      <div class="col-md-8">
                         <div><span class="text-primary" style="cursor:pointer">{{item.name}}</span></div>
                          <!-- <div class="badge badge-warning" style="color:black">{{getType(item.type)}}</div> -->

                          <div v-if="item.type=='lecture'" class="badge badge-warning" style="color:black">{{getType(item.type)}} /{{item.type}}/</div>
                          <div v-else-if="item.type=='video'" class="badge badge-warning" style="color:black">{{getType(item.type)}} /{{item.type}}/</div>
                          <div v-else-if="item.type=='seminar'" class="badge badge-warning" style="color:black">{{getType(item.type)}} /{{item.type}}/</div>

                          <div v-else-if="item.type=='coursework'" class="badge badge-info" style="color:black">{{getType(item.type)}} /{{item.type}}/</div>
                          <div v-else-if="item.type=='assignment'" class="badge badge-info" style="color:black">{{getType(item.type)}} /{{item.type}}/</div>
                          <div v-else-if="item.type=='coursework'" class="badge badge-info" style="color:black">{{getType(item.type)}} /{{item.type}}/</div>

                          <div v-else-if="item.type=='test'" class="badge badge-mydanger" style="color:black">{{getType(item.type)}} /{{item.type}}/</div>
                          <div v-else-if="item.type=='exam'" class="badge badge-mydanger" style="color:black">{{getType(item.type)}} /{{item.type}}/</div>
                          
                          <div v-else class="badge badge-warning" style="color:black">{{getType(item.type)}} /{{item.type}}/</div>
                 

                          <!-- <p class="views">xxx</p> -->
                      </div>
                  </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      
      <!-- ContentModal -->
      <div class="modal fade" id="contentModal" tabindex="-1" role="dialog" aria-labelledby="contentModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >Агуулга нэмэх</h5>
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="content">
              <form class="user">
                <div class="form-group">
                  <label>Агуулгын нэр: </label>
                  <input v-model.trim="content.name" class="form-control" placeholder="Агуулгын нэр">
                </div>

                <div class="form-group">
                  <label>Агуулгын дэлгэрэнгүй тайлбар: </label>
                  <textarea rows="2" v-model.trim="content.description" class="form-control"  placeholder="Агуулгын дэлгэрэнгүй"/>
                </div>
                <div class="form-group">
                  <label>Youtube видеоны линк: </label>
                  <input v-model.trim="content.videoUrl" class="form-control" placeholder="Видеоны линк">
                </div>
                <div class="form-group">
                  <label>IFrame линк/Жишээлбэл: GoogleDoc, Slide, Microsoft office, Slideshare .../ </label>
                  <textarea rows="2" v-model.trim="content.iframeurl" class="form-control"  placeholder=""/>
                </div>
                <div class="form-group">
                  <label for="exampleFormControlSelect1">Агуулгын төрөл: </label>
                  <select class="form-control" v-model="selectedType" >
                    <option v-for="(type) in types" v-bind:key="type.id" v-bind:value="type.id">{{type.title}}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Эхлэх: </label>
                  <input v-model="content.startDayStr" class="form-control form_datetime" type="date" placeholder="Агуулга нээгдэх хугацаа" >
                </div>
                <div class="form-group">
                  <label>Дуусах: </label>
                  <input v-model="content.endDayStr" class="form-control form_datetime" type="date" placeholder="Агуулга дуусах хугацаа">
                </div>
                <div class="form-group" v-if="selectedType=='exam'">
                  <label>Шалгалтын хугацаа/мин/: </label>
                  <input v-model.number="content.time" class="form-control" type="number" placeholder="">
                </div>
                <div class="form-group" v-else>
                  <label>Видеоны хугацаа/мин/: </label>
                  <input v-model.number="content.duration" class="form-control" type="number" placeholder="">
                </div>
                <div class="row" v-if="selectedType && selectedType=='assignment'">
                  <div class="col">
                    <div class="form-check">
                      <input type="checkbox" v-model="content.graded" class="form-check-input" id="exampleCheck1">
                      <label class="form-check-label" for="exampleCheck1">Оноотой эсэх</label>
                    </div>
                  </div>
                  <div class="col" v-if="content && content.graded && content.graded==true">
                    <div class="form-group">
                      <label>Дүгнэх дээд оноо: </label>
                      <input v-model.number="content.totalScore" class="form-control" type="number" placeholder="Дээд оноо">
                    </div>
                  </div>
                </div>
     

                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
              <button @click="saveContent(selectedTopic)" type="button" class="btn btn-primary btn-user btn-block">Хадгалах</button>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade" id="submodal" tabindex="-1" role="dialog" aria-labelledby="submodalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body" v-if="sub">
              <form class="user">
                <div class="form-group">
                  <label>Заасан агуулгын нэр: </label>
                  <input v-model.trim="sub.name" class="form-control" placeholder="Заасан агуулгын нэр">
                </div>
              
                <hr>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
              <button @click="saveSubContent(sub)" type="button" class="btn btn-primary btn-user btn-block">Хадгалах</button>
            </div>
          </div>
        </div>
      </div>


      <!-- FileModal -->
      <div class="modal fade" id="fileModal" tabindex="-1" role="dialog" aria-labelledby="fileModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content" v-if="item">
            <div class="modal-header">
              <div class="row">
                <div class="col">
                  <h5 class="modal-title" >Файл оруулах</h5>
                </div>
                <div class="col">
                  {{item.name}}
                </div>
              
              </div>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="form-group">
                  <label>Гарчиг: </label>
                  <input v-model.trim="filecontent.name" class="form-control" placeholder="Гарчиг">
                </div>
                <div class="form-group">
                  <label>Дэлгэрэнгүй тайлбар: </label>
                  <textarea rows="2" v-model.trim="filecontent.description" class="form-control"  placeholder="дэлгэрэнгүй"/>
                </div>
                <div class="form-group">
                  <label>Файл татах холбоос линк: </label>
                  <input v-model.trim="filecontent.link" class="form-control" placeholder="Линк /файл татах холбоос/">
                </div>

                <hr>
                <p class="text-center text-danger">Жишээлбэл та Google Drive файлын 'share link' хуулж тавьж болно.</p>
                <p class="text-center text-danger py-2" style="border:1px dashed #1cc88a;border-radius: 15px;">
                  
                  Хэрэв та Google Drive файл оруулах гэж байгаа бол <img src="/assets/img/file_ins.png"/> ➔ <img src="/assets/img/file_ins_1.png"/> буюу public тохиргоотой линкийг хуулж тавиарай.!!!
                </p>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Хаах</button>
              <button @click="saveContentFile" type="button" class="btn btn-primary btn-user btn-block">Хадгалах</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import LessonHeader from '../shared/ILessonHeader'

export default {
    name: "IContentDetail",
    components:{
      LessonHeader
    },
    data() {
        return {
            lesson: null,
            topic:null,
            item:null,
            types:[],
            selectedType:null,
            content:{

            },
            itemDetails:[],
            selectedTopic:null,

            display:0,
            topicBucket:'lessonTopicFiles/',
            sub:{
              "name":null
            },
            filecontent:{
              name:null,
              link:null,
              description:null
            },
            semesters:[],
            school:null,
            topics:[],
            commentText:null
        };
    },
    methods: {
      setCurrentVideo(topic, item){
        this.$nextTick(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.topic=topic;
           this.item = item;
          this.itemDetails=[];
        });
       
      },
        
      _getQA(){

        fb.db
          .doc("lessons/" + this.lessonId)
          .collection("topics")
          .orderBy("createdAt", "desc")
          .get().then((querySnapshot) => {
            this.topics = [];
            querySnapshot.forEach((doc) => {
              let object = doc.data();
              object.id = doc.id;
              object.details = [];
              if (!object.published) object.published = null;
              doc.ref
                .collection("details")
                .orderBy("createdAt")
                .onSnapshot((contentSnapshot) => {
                  object.details = [];
                  contentSnapshot.forEach((contentDoc) => {
                    let content = contentDoc.data();
                    content.id = contentDoc.id;
                    content.uploading = false;
                    content.uploadPercent = 0;
                    content.comments=[];

                    contentDoc.ref.collection("content_comments").orderBy("createdAt", "desc").onSnapshot(cquerysnapshot=>{
                      content.comments=[];
                      if(cquerysnapshot && !cquerysnapshot.empty){
                        cquerysnapshot.docs.forEach(cdoc=>{
                          if(cdoc.exists){
                            let comment=cdoc.data();
                            comment.id=cdoc.id;
                            comment.customerData=null;
                            if(comment.customer){
                              comment.customer.get().then(studentData=>{
                                comment.customerData=studentData.data();
                              });
                            }
                            content.comments.push(comment);
                          }
                        });
                      }
                    });
                    object.details.push(content);
                  });
                });
              this.topics.push(object);
            });
          });


        fb.db.collection("lessons").doc(this.lessonId).get().then(doc=> {
            let lesson=doc.data();
            lesson.id=doc.id;
            this.lesson=lesson;
            doc.ref.collection("topics").doc(this.topicId).get().then(tdoc=>{
              if(tdoc.exists){
                let topic=tdoc.data();
                topic.id=tdoc.id;
                this.topic=topic;

                tdoc.ref.collection("details").doc(this.contentId).onSnapshot(cdoc=>{
                  if(cdoc.exists){
                    let item=cdoc.data();
                    item.id=cdoc.id;
                    item.uploading=false;
                    item.uploadPercent=0;
                    if(!item.startDayStr)
                      item.startDayStr=null;
                    if(!item.endDayStr)
                      item.endDayStr=null;
                    if(!item.startDay)
                      item.startDay=null;
                    if(!item.endDay)
                      item.endDay=null;
                    if(item && item.iframeurl){
                      if(item.iframeurl.includes("docs.google.com/document")){
                        item.iframeurl=item.iframeurl.replace("<iframe ", "<iframe style='height:1024px'");
                      }
                    }
                    item.comments=[];

                    cdoc.ref.collection("content_comments").orderBy("createdAt", "desc").onSnapshot(cquerysnapshot=>{
                      content.comments=[];
                      if(cquerysnapshot && !cquerysnapshot.empty){
                        cquerysnapshot.docs.forEach(commentdoc=>{
                          if(commentdoc.exists){
                            let comment=commentdoc.data();
                            comment.id=commentdoc.id;
                            comment.customerData=null;
                            if(comment.customer){
                              comment.customer.get().then(studentData=>{
                                comment.customerData=studentData.data();
                              });
                            }
                            item.comments.push(comment);
                          }
                        });
                      }
                    });
                    this.item=item;
                    cdoc.ref.collection("subdetails").orderBy("createdAt", "desc").onSnapshot(docs=>{
                      if(docs!=null && !docs.empty){
                        this.itemDetails=docs.docs;
                      }
                    });
                  }
                });
              }
            });
          
        });

          fb.db.collection("ContentTypes").get().then(querySnapshot=> {
              this.types=[]
              querySnapshot.forEach(doc=> {
                let object=doc.data()
                object.id = doc.id
                object.content=[]
                this.types.push(object);
              });
            
          });

      },
      saveContent(topic) {
        if(this.content!=null && this.content.name!=null && this.content.name!='' && this.selectedType!=null){
          if(this.content.videoUrl!=null && this.content.videoUrl!='' ){
            if (this.content.videoUrl.toLowerCase().indexOf("youtube") == -1) {
              alert("Та заавал youtube бичлэг оруулна уу");
              return;
            }
          }
          this.content.typeRef=fb.db.collection("ContentTypes").doc(this.selectedType);
          this.content.type=this.selectedType;
        
          if(this.lesson!=null && this.topic!=null && this.topic.id!=null && this.content)
            
              if(this.content.startDayStr!=null && this.content.startDayStr!=''){
                this.content.startDay=new Date(this.content.startDayStr);
                console.log(this.content)
              }

              if(this.content.endDayStr!=null && this.content.endDayStr!=''){
                this.content.endDay=new Date(this.content.endDayStr);
              }
                  
              if(this.selectedType!=null && this.selectedType=="exam"){
                this.content.roundCount=1;
              }
              else if(this.selectedType!=null && this.selectedType=="test"){
                this.content.roundCount=10;
              }

              if(this.content.id!=undefined && this.content.id!=null && this.content.id!='' && this.content.id!='new'){
                this.content.modifiedAt=new Date();
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.content.id).update(this.content)
              }
              else{
                this.content.createdAt=new Date();
                this.content.code=new Date().getTime().toString();
                fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc().set(this.content)

                
                if(this.content.videoUrl!=null && this.content.videoUrl!=''){
                  fb.db.collection("lessons").doc(this.lessonId).update({
                    'numberOfVideos':fb.firestore.FieldValue.increment(1)
                  });
                }

              }
              

              this.selectedType=null;
              this.selectedTopic=null;
              this.content={
                'name':null,
                'description':null,
                'videoUrl':null,
                'published':false,
                'startDay':null,
                'endDay':null,
                'code':null,
                'duration':null,
                'shortname':null,
                iframeurl:null
              }
          $('#contentModal').modal('hide');
        
        } 
        else{
          alert("Та талбаруудыг гүйцэд бөглөнө үү");
        }
      },
      // saveSubContent(sub){
      //   if(sub!=null && sub.name!=null && sub.name!=''){

        
      //     if(this.lesson!=null && this.topic!=null && this.topic.id!=null && this.item!=null && this.item!=undefined){
      //         if(sub.id!=undefined && sub.id!=null && sub.id!='' && sub.id!='new'){
      //           sub.modifiedAt=new Date();
      //           fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id).collection("subdetails").doc(sub.id).update(sub);
      //         }
      //         else{
      //           sub.createdAt=new Date();
      //           fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id).collection("subdetails").doc().set(sub);
      //           fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id).update(
      //             { "numberOfSubdetails": fb.firestore.FieldValue.increment(1) }
      //           );
      //           fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).update(
      //             { "numberOfSubdetails": fb.firestore.FieldValue.increment(1) }
      //           );
      //           fb.db.collection('schools/'+this.schoolId+"/lessons").doc(this.lessonId).update(
      //             { "numberOfSubdetails": fb.firestore.FieldValue.increment(1) }
      //           );
      //         }
              
      //         this.sub={
      //           'name':null
      //         }
    
      //     }
      //     $('#submodal').modal('hide');
      //   }
      //   else{
      //     alert("Та талбаруудыг гүйцэд бөглөнө үү");
      //   }
      // },
      openSubContentModal(){
        this.sub={name:null};
        $('#submodal').modal('show');

      },
      _editSub(subdetail){
        this.sub={
          id: subdetail.id,
          name: subdetail.data().name
        };
        $('#submodal').modal('show');
      },
      openSaveContentModal(topic){
        this.selectedTopic=topic;
        $('#contentModal').modal('show');

      },

      goStat(type, topic){
        this.$router.push({ name: 'TopicStat', params: { lessonId: this.lessonId, type: type.id, topicId: topic.id} })
      },


 
      _editContent(content, topic){
          this.content= Object.assign({}, content);
          this.selectedType=content.type;
          $('#contentModal').modal('toggle');
      },

      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },

      setPublished(value, lesson){
        this.setProperty("published", fb.db.doc("lessons/"+lesson.id), value);
        if(value==true){
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(1)});

          var publish = firebase.functions().httpsCallable('publishLesson');
          publish(
            { lessonId: lesson.id}
          );
        }
        else{
          if(lesson.school!=null && lesson.school!=undefined)
            lesson.school.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.department!=null && lesson.department!=undefined)
            lesson.department.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          if(lesson.program!=null && lesson.program!=undefined)
            lesson.program.update({"publishedLesson": fb.firestore.FieldValue.increment(-1)});
          var unpublish = firebase.functions().httpsCallable('unPublishLesson');
          unpublish(
            { lessonId: lesson.id}
          );
        }
      },
      setPropContent(value,topic, item, propertyName){
        if(this.lesson!=null && topic!=null && item!=null && propertyName!=null)
          this.setProperty(propertyName, fb.db.doc("lessons/"+this.lesson.id+"/topics/"+topic.id+"/details/"+item.id), value);

        item[propertyName]=value;
      },
      setProperty(propertyName, object, value){
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.update(tmp);
        }
      },
      uploadFile(topic, content){
        var _this=this;

        var files = this.$refs['file_'+content.id].files;
        if(files!=null && files.length>0){
          var file=files[0];
          if(file.name.endsWith("mp4") 
            || file.name.endsWith("MP4") 
            || file.name.endsWith("MPEG") 
            || file.name.endsWith("mov") || file.name.endsWith("MOV")
            || file.name.endsWith("webm") || file.name.endsWith("WEBM")
          )
          {
            alert("Та video файл оруулах боломжгүй");
            return;
          }
          var now=new Date();
          var fileName=this.topicBucket+"_" +now.getTime()+"_"+file.name;
          var uploadTask = fb.storageRef.child(fileName).put(file);
          content.uploading=true
          content.uploadPercent=0
          uploadTask.on(fb.storage.TaskEvent.STATE_CHANGED,
            function(snapshot) {
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              content.uploadPercent=progress
            }, function(error) {
            switch (error.code) {
              case 'storage/unauthorized':
                break;

              case 'storage/canceled':
                break;
              case 'storage/unknown':
                break;
            }
          }, 
          function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              
              let fileObject={
                'fileName': fileName,
                'fileUrl':downloadURL,
                'realName': file.name,
                'uploadedAt': now
              }
              fb.db.collection("lessons").doc(_this.lessonId).collection("topics").doc(topic.id).collection("details").doc(content.id).update(
                {
                    files: fb.firestore.FieldValue.arrayUnion(fileObject)
                }
              )
              content.uploading=false
              content.uploadPercent=0
             
            });
          });
        }
        
      },
      _deleteTopicFile(topic,content, file, index){
        var result = confirm("Та "+file.fileName+" файлыг устгах уу?");
          if (result) {
            var fileName=file.fileName;
            var fileRef = fb.storageRef.child(fileName);
            fileRef.delete();
              content.files.splice(index, 1)
              fb.db.collection("lessons").doc(this.lessonId).collection("topics/"+topic.id+"/details").doc(content.id).update({
                  files: content.files
                }
              );
              
          }
      }
      ,
      validFile(file){
        if(file.fileName.endsWith("mp4") 
            || file.fileName.endsWith("MP4") 
            || file.fileName.endsWith("MPEG") 
            || file.fileName.endsWith("mov") || file.fileName.endsWith("MOV")
            || file.fileName.endsWith("webm") || file.fileName.endsWith("WEBM")
          ){
            return false;
        }
        return true;
      },
      getYoutubeId(url) {
          const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
          const match = url.match(regExp);

          return (match && match[2].length === 11)
            ? match[2]
            : null;
      },
      getYoutubeImg(url){
        if(url){
          var id=this.getYoutubeId(url);
          if(id){
            return "https://img.youtube.com/vi/"+id+"/1.jpg";
          }
        }
        return null;
      },
      getYoutubeIframe(url){
        if(url!=null && url!='' && url.toLowerCase().indexOf("youtube") != -1){
          var id= this.getYoutubeId(url);
          return 'https://www.youtube.com/embed/' + id ;
        }
        return null;
      },
      getType(type){
        if(type=="test")
          return "Тест давтлага";
        else if(type=="video")
          return "Хичээл";
        else if(type=="lecture")
          return "Хичээл";
        else if(type=="seminar")
          return "Семинар";
        else if(type=="exam")
          return "Шалгалт";
        else if(type=="homework")
          return "Гэрийн даалгавар";
        else if(type=="coursework")
          return "Бие даалт";
        else if(type=="assignment")
          return "Даалгавар";
        
      },
      openSaveContentFileModal(topic, content){
        this.filecontent={
          name:null,
          link:null,
          description:null
        };
        $('#fileModal').modal('show');
      },
      async saveContentFile(){
        if(this.topic && this.content && this.filecontent && this.filecontent.link){
          await fb.db.collection("lessons").doc(this.lessonId)
          .collection("topics").doc(this.topic.id)
          .collection("details").doc(this.item.id)
          .update({fileUrls:fb.firestore.FieldValue.arrayUnion(this.filecontent)});

          if(!this.item.fileUrls)
            this.item.fileUrls=[];
          this.item.fileUrls.push(this.filecontent);
          $('#fileModal').modal('hide');

        }
        else{
          alert("Та файлын мэдээллээ бүрэн оруулна уу.");
        }

        this.filecontent={
          name:null,
          link:null,
          description:null
        };
      },
      _deleteContentFile(topic, content, file, index){
        var result = confirm("Та "+file.link+" файлыг устгах уу?");
        if (result) {

          content.fileUrls.splice(index, 1);
          fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(topic.id+"/details/"+content.id).update({
              fileUrls: content.fileUrls
            }
          );

        }
      },
      async saveComment(){
        if(this.commentText && this.commentText!='' && this.commentText.length>=2 && this.userProfile && this.userProfile.customer){
          var contentRef=fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id).collection("details").doc(this.item.id);
          await contentRef.collection("content_comments").doc().set(
            {
              createdAt:new Date(),
              customer:this.userProfile.customer,
              user: fb.db.collection("users").doc(this.currentUser.uid),
              text:this.commentText,
              content: contentRef,
              topic: fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topic.id),
              lesson:fb.db.collection("lessons").doc(this.lessonId),
            

            }
          );
          contentRef.update({numberOfComments:fb.firestore.FieldValue.increment(1)});
          this.commentText=null;
        }
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
      lessonId: { 
          required: true,
      },
      topicId:{
        required:true
      },
      contentId:{
        required:true
      } ,
      showContainer:{
        required:false
      }
    },
    created() {
        var _this=this;
        // $(document).ready(function() {
        //   $(function() {
        //     console.log($(".form_datetime"))
        //     // $(".form_datetime").datepicker({format: 'yyyy-mm-dd hh:ii'});
        //   });
        // });
        
        if(this.lessonId!=null && this.lessonId!='')
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

<style>
  #iframecontainer iframe{
    width:100%!important;
  }
</style>